module.exports = __webpack_public_path__ + "img/logo-js-jquery.deb5bcf0.png";